import React, { useState, useEffect } from 'react';

const PCOnlyWrapper = ({ children }) => {
  const [isMobileOrTablet, setIsMobileOrTablet] = useState(false);

  useEffect(() => {
    const checkDevice = () => {
      setIsMobileOrTablet(window.innerWidth <= 1024);
    };

    checkDevice(); // Initial check
    window.addEventListener('resize', checkDevice);
    return () => window.removeEventListener('resize', checkDevice);
  }, []);

  return (
    <div>
      {isMobileOrTablet && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            zIndex: 10000,
            width: '100vw',
            height: '100vh',
            backgroundColor: '#ffe6e6',
            color: '#b30000',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
            fontSize: '1.5rem',
            padding: '1rem',
            textAlign: 'center',
          }}
        >
          <div style={{ fontSize: '4rem', marginBottom: '1rem' }}>
            📵
          </div>
          <div style={{ maxWidth: '400px' }}>
            You can see this page only on your PC.
          </div>
        </div>
      )}
      <div style={{ visibility: isMobileOrTablet ? 'hidden' : 'visible' }}>
        {children}
      </div>
    </div>
  );
};

export default PCOnlyWrapper;
